<template>
  <div>
    <h1></h1>
    <!-- 路由出口 -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
